import { useLayoutEffect, useRef } from 'react'
import { NavLink } from 'react-router'
import { useAnmeldung } from '../lib/anmeldung'
import { Profilmenue } from './Profilmenue'

/**
 * Die Reiterzeile benennt die Seite — deshalb tragen die Seiten selbst keine
 * Ueberschrift. Aktionen gehoeren nicht hierher: sie gehoeren zu der Liste,
 * auf die sie wirken.
 */
export function Kopfzeile() {
  const { auskunft } = useAnmeldung()
  const kopf = useRef<HTMLElement>(null)

  /* Die Hoehe der Kopfzeile haengt an der Schriftgroesse und bricht auf
     schmalen Fenstern um. Was darunter kleben soll, braucht sie als Mass. */
  useLayoutEffect(() => {
    const kasten = kopf.current
    if (!kasten) return
    const messen = () => document.documentElement.style.setProperty('--kopf-hoehe', `${kasten.offsetHeight}px`)
    messen()
    const beobachter = new ResizeObserver(messen)
    beobachter.observe(kasten)
    return () => beobachter.disconnect()
  }, [auskunft])

  if (!auskunft) return null
  const verwaltung = auskunft.benutzer.rolle === 'verwaltung'
  const reiter = ({ isActive }: { isActive: boolean }) => (isActive ? 'aktiv' : '')

  return (
    <header className="kopf" ref={kopf}>
      <div className="kopf-oben">
        <div className="wortmarke">
          H&amp;K <span>Automation</span>
        </div>
        <div className="kopf-luecke" />
        <Profilmenue />
      </div>

      <div className="kopf-unten">
        <nav className="reiter">
          {verwaltung ? (
            <NavLink to="/verwaltung" className={reiter}>Kanzleien</NavLink>
          ) : (
            <>
              <NavLink to="/eingang" className={reiter}>Eingang</NavLink>
              <NavLink to="/mandanten" className={reiter}>Mandanten</NavLink>
              <NavLink to="/exporte" className={reiter}>Exporte</NavLink>
            </>
          )}
        </nav>
      </div>
    </header>
  )
}
